import React, { useEffect, useState } from 'react'

function CreateCustomFood() {
  return (
    <>
      <h3>Novo Alimento Personalizado</h3>
      Food
    </>
  )
}

export default CreateCustomFood